module.exports = __webpack_public_path__ + "static/media/slim-branco.8ff94388.webp";